import Navigate             from "Dashboard/Core/Navigate";
import Store                from "Dashboard/Core/Store";
import DateTime             from "Dashboard/Utils/DateTime";
import Utils                from "Dashboard/Utils/Utils";
import { Shift }            from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    statuses  : [],
    filters   : {
        search   : "",
        status   : "",
        fromDate : "",
        toDate   : "",
    },
    sort       : {
        orderBy  : "fromTime",
        orderAsc : 0,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "SHIFT_LOADING" });
    },

    /**
     * Fetches the Shift List
     * @param {Function} dispatch
     * @param {String=}  type
     * @param {Number=}  elemID
     * @param {Object=}  filters
     * @param {Object=}  sort
     * @returns {Promise}
     */
    async fetchList(dispatch, type = "", elemID = 0, filters = {}, sort = {}) {
        const params = { ...filters, ...sort };
        Navigate.unsetParams(params);
        if (type === "ACTIVITY") {
            params.activityID = elemID;
        }

        const data   = await Shift.getAll(params);
        data.filters = filters;
        data.sort    = sort;
        dispatch({ type : "SHIFT_LIST", data });
    },

    /**
     * Fetches a single Shift
     * @param {Function} dispatch
     * @param {Number}   shiftID
     * @returns {Promise}
     */
    async fetchElem(dispatch, shiftID) {
        const data = await Shift.getOne({ shiftID });
        dispatch({ type : "SHIFT_ELEM", data });
    },

    /**
     * Fetches the Shift Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await Shift.getEditData();
        dispatch({ type : "SHIFT_EDIT", data });
    },

    /**
     * Edits/Creates a Shift
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return Shift.edit(data);
    },

    /**
     * Deletes a Shift
     * @param {Function} dispatch
     * @param {Number}   shiftID
     * @returns {Promise}
     */
    deleteElem(dispatch, shiftID) {
        return Shift.delete({ shiftID });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.date                  = DateTime.formatDate(elem.fromTime, "dashesReverse");
    elem.fromTimeDate          = DateTime.formatDate(elem.fromTime, "dashes");
    elem.fromHour              = DateTime.formatDate(elem.fromTime, "time");
    elem.toHour                = DateTime.formatDate(elem.toTime, "time");
    elem.availableFromDateTime = DateTime.formatDate(elem.availableFromTime, "dashesTime");
    elem.availableFromDate     = DateTime.formatDate(elem.availableFromTime, "dashesReverse");
    elem.availableFromHour     = DateTime.formatDate(elem.availableFromTime, "time");
    elem.availableToDateTime   = DateTime.formatDate(elem.availableToTime, "dashesTime");
    elem.availableToDate       = DateTime.formatDate(elem.availableToTime, "dashesReverse");
    elem.availableToHour       = DateTime.formatDate(elem.availableToTime, "time");

    elem.scheduleText      = `${elem.fromHour} - ${elem.toHour}`;
    elem.subscriptionText  = `${elem.totalSubscriptions} / ${elem.totalAmount}`;
    if (elem.extraAmount > 0) {
        elem.subscriptionText += ` (+${elem.extraAmount})`;
    }
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "SHIFT_LIST", "SHIFT_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "SHIFT_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "SHIFT_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : Utils.parseList(action.data.list, parseElem),
            total     : action.data.total,
            statuses  : action.data.statuses,
            filters   : action.data.filters,
            sort      : action.data.sort,
        };

    case "SHIFT_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : parseElem(action.data.elem),
            statuses  : action.data.statuses,
        };

    case "SHIFT_EDIT":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            statuses  : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
